import { render, staticRenderFns } from "./time-dimension-selection.vue?vue&type=template&id=443974a2"
import script from "./time-dimension-selection.vue?vue&type=script&lang=ts"
export * from "./time-dimension-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports